if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-cart-drawer-upsell-add]');
        this.errorMessage = this.querySelector('.cart-drawer-upsell__error');
        this.cartDrawer = this.closest('cart-drawer');

        if (!this.button) return;

        this.button.addEventListener('click', this.addToCart.bind(this));
        this.drawerObserver = new MutationObserver(this.handleDrawerState.bind(this));

        if (this.cartDrawer) {
          this.drawerObserver.observe(this.cartDrawer, { attributes: true, attributeFilter: ['class'] });
          this.handleDrawerState();
        }
      }

      disconnectedCallback() {
        if (this.drawerObserver) this.drawerObserver.disconnect();
      }

      handleDrawerState() {
        if (!this.cartDrawer) return;

        const trackingKey = this.dataset.productId || 'unknown';

        if (this.cartDrawer.classList.contains('active')) {
          if (this.cartDrawer.dataset.upsellImpressionTracked !== trackingKey) {
            this.track('cart_drawer_upsell_impression');
            this.cartDrawer.dataset.upsellImpressionTracked = trackingKey;
          }
        } else {
          delete this.cartDrawer.dataset.upsellImpressionTracked;
        }
      }

      async addToCart(event) {
        event.preventDefault();
        if (this.button.disabled) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const variantId = this.button.dataset.variantId;

        if (!cartDrawer || !variantId) return;

        this.setLoading(true);
        this.showError();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          cartDrawer
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        try {
          const response = await fetch(routes.cart_add_url, config);
          const cartState = await response.json();

          if (!response.ok || cartState.status) {
            throw new Error(cartState.description || cartState.message || window.cartStrings.error);
          }

          this.track('cart_drawer_upsell_add');

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-upsell',
              productVariantId: variantId,
              cartData: cartState,
            });
          }

          cartDrawer.setActiveElement(this.button);
          cartDrawer.renderContents(cartState);
        } catch (error) {
          this.showError(error.message || window.cartStrings.error);
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.button.disabled = isLoading;
        this.button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        this.button.classList.toggle('loading', isLoading);

        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }

      showError(message = '') {
        if (!this.errorMessage) return;

        this.errorMessage.textContent = message;
        this.errorMessage.hidden = !message;
      }

      track(eventName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          cart_drawer_upsell: {
            product_id: this.dataset.productId,
            product_title: this.dataset.productTitle,
            price: Number(this.dataset.productPrice || 0) / 100,
            currency: this.dataset.currency,
          },
        });
      }
    }
  );
}
